import React from 'react';
import './ContactModal.css';
import { AnimatePresence, motion } from 'motion/react';

const ContactModal = ({ isOpen, onClose, children, type = 'center' }) => {
  const overlayTransition = {
    duration: 0.25,
    ease: 'easeOut',
  };

  const contentTransition = {
    duration: 0.35,
    ease: [0.25, 1, 0.5, 1],
  };

  const contentAnimation =
    type === 'right'
      ? {
          initial: { x: '100%' },
          animate: { x: 0 },
          exit: { x: '100%' },
        }
      : {
          initial: { opacity: 0, scale: 0.95, y: 16 },
          animate: { opacity: 1, scale: 1, y: 0 },
          exit: { opacity: 0, scale: 0.95, y: 16 },
        };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="modal-overlay"
          onClick={onClose}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={overlayTransition}
        >
          {/* type can be 'center' or 'right' */}
          <motion.div
            className={`modal-content ${type}`}
            onClick={(e) => e.stopPropagation()}
            initial={contentAnimation.initial}
            animate={contentAnimation.animate}
            exit={contentAnimation.exit}
            transition={contentTransition}
          >
            <button className="close-btn" onClick={onClose}>&times;</button>
            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ContactModal;
